import aqaIcon from '@/images/exam-boards/aqa.svg'
import cieIcon from '@/images/exam-boards/cie.svg'
import edexcelIcon from '@/images/exam-boards/edexcel.svg'
import ibIcon from '@/images/exam-boards/ib.svg'
import meiIcon from '@/images/exam-boards/mei.svg'
import ocrIcon from '@/images/exam-boards/ocr.svg'
import ialIcon from '@/images/interactive-video-course/icons/ial.svg'
import { ExamBoards, IBookedCourseDetailed } from '@/types/firebase'
import { StaticImageData } from 'next/image'

export const EXAM_BOARD_ICONS: { [key in ExamBoards]: StaticImageData } = {
  AQA: aqaIcon,
  CIE: cieIcon,
  Edexcel: edexcelIcon,
  IB: ibIcon,
  MEI: meiIcon,
  OCR: ocrIcon,
}

export const getExamBoardIconByCourse = (
  course: IBookedCourseDetailed,
  userExamBoard?: ExamBoards,
): StaticImageData => {
  let icon: StaticImageData = ialIcon

  const examBoards = course.examBoards

  if (!examBoards || examBoards.length === 0) {
    return icon
  }

  let targetBoard =
    userExamBoard && examBoards.includes(userExamBoard)
      ? userExamBoard
      : examBoards[0]

  const targetIcon: StaticImageData | undefined = EXAM_BOARD_ICONS[targetBoard]

  if (targetIcon) {
    icon = targetIcon
  }

  return icon
}

export const getExamBoardIcon = (examBoard?: ExamBoards): StaticImageData => {
  let icon: StaticImageData = ialIcon

  if (!examBoard) {
    return icon
  }

  const targetIcon: StaticImageData | undefined = EXAM_BOARD_ICONS[examBoard]

  if (targetIcon) {
    icon = targetIcon
  }

  return icon
}
